/**
 * Stabilize --viewport-height on mobile in-app browsers (Facebook iOS, etc.).
 * Ignores small innerHeight flicker from browser chrome; debounces real changes.
 */
(function () {
  var lastHeight = 0;
  var lastWidth = 0;
  var timer = null;
  var THRESHOLD_PX = 80;
  var DEBOUNCE_MS = 180;

  function readHeight() {
    if (window.visualViewport && window.visualViewport.height) {
      return Math.round(window.visualViewport.height);
    }
    return window.innerHeight;
  }

  function readWidth() {
    if (window.visualViewport && window.visualViewport.width) {
      return Math.round(window.visualViewport.width);
    }
    return window.innerWidth;
  }

  function apply(force) {
    var h = readHeight();
    var w = readWidth();
    if (!force && lastHeight && Math.abs(h - lastHeight) < THRESHOLD_PX && w === lastWidth) {
      return false;
    }
    lastHeight = h;
    lastWidth = w;
    document.documentElement.style.setProperty('--viewport-height', h + 'px');
    return true;
  }

  function schedule(force) {
    if (force) {
      clearTimeout(timer);
      apply(true);
      return;
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      apply(false);
    }, DEBOUNCE_MS);
  }

  window.bambeSyncViewportHeight = schedule;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      schedule(true);
    });
  } else {
    schedule(true);
  }

  window.addEventListener(
    'resize',
    function () {
      schedule(false);
    },
    { passive: true }
  );

  if (window.visualViewport) {
    window.visualViewport.addEventListener(
      'resize',
      function () {
        schedule(false);
      },
      { passive: true }
    );
  }
})();
